import { Page, Modal, Alert, Events, NavController, NavParams, Loading } from 'ionic-angular'
import { Component } from '@angular/core'
import { Http } from '@angular/http'
import { SearchModal } from '../search/search'
import { ChoicePage } from '../itinerary/choice'
import { DOMAIN } from '../../config'

@Component({
  templateUrl: 'build/pages/itinerary/itinerary.html'
})
export class ItineraryPage {
  private start: any
  private end: any
  private way: any
  private date: any
  private time: any

  constructor(private events: Events, private nav: NavController, private http: Http, private params: NavParams) {
    this.start = null
    this.end = null
    this.way = 'departure'

    // Get route params 
    if (params.get('start') && params.get('end')) {
      this.start = params.get('start')
      this.end = params.get('end')
    }

    this.date = new Date().toISOString()
    this.time = new Date().getHours() + ':' + new Date().getMinutes()

    this.events.subscribe('carpostal:search:selected', (data) => {
      let input = data[0]
      let place = data[1]

      // Build google coords from place retrieved
      let type = place.embedded_type
      let coords = place[type].coord
      let location = new google.maps.LatLng(coords.lat, coords.lon)

      if (input.parentNode.parentNode.parentNode.classList[0] === 'start') {
        this.start = location
        document.querySelector('.start ion-label').innerHTML = place.name
      } else {
        this.end = location
        document.querySelector('.end ion-label').innerHTML = place.name
      }
    })
  }

  ngAfterViewInit() {
    if (this.params.get('stop')) {
      let stop = this.params.get('stop')
      this.start = stop.getPosition()
      document.querySelector('.start ion-label').innerHTML = stop.title
    }
    document.querySelector('.end ion-label').innerHTML = 'Arrivée'

    //(<HTMLInputElement>document.querySelector('input[type="date"]')).value = moment().format('YYYY-MM-DD')
    //(<HTMLInputElement>document.querySelector('input[type="time"]')).value = moment().format('HH:mm')

    // Custom URL handling
    if (this.start && this.end) {
      let loader = Loading.create({
        content: 'Récupération des informations',
        dismissOnPageChange: true
      })
      this.nav.present(loader)

      // Retrieve all info abouts stops
      this.http.get(`//${DOMAIN}/api/stop/${encodeURIComponent(this.start)}`)
        .map(res => res.json())
        .subscribe(data => {
          if (!data.error) {
            let stop_point = data.stop_points[0]

            document.querySelector('.start ion-label').innerHTML = stop_point.label
            this.start = new google.maps.LatLng(stop_point.coord.lat, stop_point.coord.lon)

            // Get end data
            this.http.get(`//${DOMAIN}/api/stop/${encodeURIComponent(this.end)}`)
              .map(res => res.json())
              .subscribe(data => {
                if (!data.error) {
                  let stop_point = data.stop_points[0]

                  document.querySelector('.end ion-label').innerHTML = stop_point.label
                  this.end = new google.maps.LatLng(stop_point.coord.lat, stop_point.coord.lon)

                  // Ok, launch itinerary
                  setTimeout(() => {
                    loader.dismiss()
                    this.itinerary()
                  }, 250)
                } else {
                  console.log('Error end occured')
                  return
                }
              }, err => {
                console.error(err)
                loader.dismiss()
              })
          } else {
            console.log('Error start occured')
            return
          }
        }, err => {
          console.error(err)
          loader.dismiss()
        }, () => {
          console.info('stop retrieve finished')
        })
    }
  }

  search(event) {
    this.nav.present(Modal.create(SearchModal, {
      input: event.target
    }))
  }

  itinerary() {
    if (this.start === null || this.end === null) {
      this.nav.present(Alert.create({
        title: 'Attention',
        subTitle: 'Veuillez remplir tout les champs.',
        buttons: ['Ok']
      }))

      return
    }

    // Loading popup
    let loading = Loading.create({
      content: 'Recupération des données',
      dismissOnPageChange: true
    })
    this.nav.present(loading)
    
    this.date = this.date.replace(/-/g, '')
    let time = this.time.replace(/:/g, '')

    let datetime = `${this.date}T${time}`
    let from = `${this.start.lng()};${this.start.lat()}`
    let to = `${this.end.lng()};${this.end.lat()}`

    // Retrieve the next 3 itineraries
    this.http.get(`//${DOMAIN}/api/itinerary?from=${from}&to=${to}&datetime=${datetime}&datetime_represents=${this.way}&count=3`)
      .map(res => res.json())
      .subscribe(data => {
        if (data.error) {
          let message

          switch (data.error.id) {
            case 'date_out_of_bounds':
              message = 'Les données utilisées pour le plan dynamique sont effectives à partir du samedi 2 Janvier 2016.'
              break
            case 'no_origin':
              message = 'Aucune correspondance trouvée pour votre point de départ.'
              break
            case 'no_destination':
              message = 'Aucune correspondance trouvée pour votre point d\'arrivée.'
              break
            case 'no_origin_nor_destination':
              message = 'Aucune correspondance trouvée pour votre point de départ ni votre point d\'arrivée.'
              break
            case 'no_solution':
              message = 'Aucune solution trouvée avec vos paramètres.'
              break
          }

          this.nav.present(Alert.create({
            title: 'Attention',
            subTitle: message
          }))
        } else {
          this.nav.push(ChoicePage, {
            data: data,
            start: this.start,
            end: this.end
          })
        }
      }, err => console.error(err), () => console.info('journeys retrived from Navitia'))
  }

  ngOnDestroy() {
    this.events.unsubscribe('carpostal:search:selected', null)
  }
}
